import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import { ProposalNodeFragmentDoc } from '../fragments/proposalNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllProposalsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
}>;


export type AllProposalsQuery = { __typename?: 'Query', allProposals?: { __typename?: 'ProposalNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'ProposalNodeEdge', cursor: string, node?: { __typename?: 'ProposalNode', id: string, currency: Types.DealsProposalCurrencyChoices, creationTime?: any | null, updateTime?: any | null, modelYear?: number | null, freeKmPerYear?: number | null, monthlyPayment?: number | null, deposit?: number | null, carPrice?: number | null, servicePrice?: number | null, totalPrice?: number | null, baseIndex?: number | null, participationFee?: number | null, residualPrice?: number | null, trackingMonthlyRate?: number | null, comprehensiveInsurancePrice?: number | null, comprehensiveInsuranceYoungPrice?: number | null, compulsoryInsurancePrice?: number | null, licencePrice?: number | null, leaseDuration: number, dealTypeString?: string | null, notes?: string | null, isOperational: boolean, hasDeal?: boolean | null, isLocked: boolean, taxLevel?: number | null, validFrom?: any | null, validTo?: any | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, shouldUnionInvoices: boolean } | null, carSubModel?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } } | null, installations: { __typename?: 'InstallationNodeConnection', edges: Array<{ __typename?: 'InstallationNodeEdge', node?: { __typename?: 'InstallationNode', id: string, name: string, priceWithoutVat: any, installationType: Types.DealsInstallationInstallationTypeChoices, isCustomerPaid: boolean } | null } | null> } } | null } | null> } | null };


export const AllProposalsDocument = gql`
    query AllProposals($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $text: String, $customer: Float) {
  allProposals(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    text: $text
    customer: $customer
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...ProposalNode
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}
${ProposalNodeFragmentDoc}`;

/**
 * __useAllProposalsQuery__
 *
 * To run a query within a React component, call `useAllProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProposalsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      text: // value for 'text'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useAllProposalsQuery(baseOptions?: Apollo.QueryHookOptions<AllProposalsQuery, AllProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllProposalsQuery, AllProposalsQueryVariables>(AllProposalsDocument, options);
      }
export function useAllProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllProposalsQuery, AllProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllProposalsQuery, AllProposalsQueryVariables>(AllProposalsDocument, options);
        }
export type AllProposalsQueryHookResult = ReturnType<typeof useAllProposalsQuery>;
export type AllProposalsLazyQueryHookResult = ReturnType<typeof useAllProposalsLazyQuery>;
export type AllProposalsQueryResult = Apollo.QueryResult<AllProposalsQuery, AllProposalsQueryVariables>;